import { render, staticRenderFns } from "./CommissionInsuredColumn.vue?vue&type=template&id=fe724a42&scoped=true&"
import script from "./CommissionInsuredColumn.vue?vue&type=script&lang=js&"
export * from "./CommissionInsuredColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe724a42",
  null
  
)

export default component.exports